import React, { useEffect, useState } from "react";

import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Input } from "./input_component";

function CustomCheckboxes(props) {
  const { label, checkboxes, textbox } = props.componentObject;

  const [showTextbox, setShowTextbox] = useState(false);

  useEffect(() => {
    checkboxes.forEach((item) => {
      if (item.state) {
        setShowTextbox(true);
      }
    });
  }, [checkboxes]);

  const classes = useStyles();

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>

      <Grid item container xs={12} md={7}>
        {checkboxes.map((checkbox, idx) => (
          <Grid item xs={6} style={{ marginBottom: 20 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkbox.status}
                  onChange={(e) => checkbox?.onChange(e.target.checked, idx, checkbox.type)}
                  //   onChange={e => console.log(e.target.checked)}
                  name={checkbox.name}
                />
              }
              label={checkbox.label}
            />
          </Grid>
        ))}
        {textbox && showTextbox && (
          <Grid item xs={12}>
            <Input componentObject={props.componentObject} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default CustomCheckboxes;

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
}));
